<template>
  <div class="date-container">
    <div class="icon-date">
      <v-icon small>mdi-calendar-blank</v-icon>
      <Typography variant="body-2"
        >Sales: {{ claim.salesDate ? formatDate(claim.salesDate) : "N/A" }}</Typography
      >
    </div>
    <div class="icon-date">
      <v-icon small>mdi-calendar-blank</v-icon>
      <Typography variant="body-2"
        >Claim: {{ claim.claimDate ? formatDate(claim.claimDate) : "N/A" }}</Typography
      >
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import moment from "moment";

export default {
  name: "ClaimDates",
  components: {
    Typography,
  },
  methods: {
    formatDate(date) {
      return moment(date).local().format("M/DD/YYYY");
    },
  },
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.date-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1.5rem;
}

.icon-date {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 0.25rem;
}
</style>
